// Catálogo canônico dos módulos + submódulos comercializáveis do kzerosystem.
// FONTE DA VERDADE: espelha `MODULES` + `SUBMODULES` (não-core, liberáveis) de
// `lib/modulos.ts` do repositório kzero-system, mais alguns submódulos que
// existem como rota mas ainda não têm entrada canônica lá (marcados como
// 'novo-sidebar' — Lista de Documentos, Certificados de Material, Gestão
// de Prospecção).
//
// A cada linha de submódulo, Bianca preenche `valorUnitario` (R$/mês por empresa
// contratada). O preço do módulo é a SOMA dos submódulos selecionados no orçamento.

export const CATALOGO_SEED = [
  {
    slug: 'negocio',
    label: 'Negócio',
    description: 'Reuniões, contexto, análise crítica, processos, riscos, pesquisas, mudança, treinamento de IA.',
    valorModulo: null,
    submodulos: [
      { slug: 'negocio.reunioes',       label: 'Reuniões',                 valorUnitario: null },
      { slug: 'negocio.contexto',       label: 'Análise e Contexto',       valorUnitario: null },
      { slug: 'negocio.analise-critica', label: 'Análise Crítica',         valorUnitario: null },
      { slug: 'negocio.processos',      label: 'Mapa de Processos',        valorUnitario: null },
      { slug: 'negocio.riscos',         label: 'Riscos e Oportunidades',                   valorUnitario: null },
      { slug: 'negocio.swot',           label: 'Matriz SWOT',              valorUnitario: null },
      { slug: 'negocio.pesquisas',      label: 'Pesquisas',                valorUnitario: null },
      { slug: 'negocio.mudanca',        label: 'Planejamento de Mudança',  valorUnitario: null },
      { slug: 'negocio.okrs',           label: 'OKRs',                     valorUnitario: null },
      { slug: 'negocio.treinamento-ia', label: 'Treinamento da IA',        valorUnitario: null },
    ],
  },
  {
    slug: 'documentos',
    label: 'Gestão de Documentos',
    description: 'Controle de documentos: lista mestra (com importação em massa e categorias), documentos gerados pelo sistema, controle de desenhos, certificados de material.',
    valorModulo: null,
    submodulos: [
      { slug: 'documentos.lista',                    label: 'Lista de Documentos',      valorUnitario: null },
      { slug: 'documentos.gerados',                  label: 'Documentos Gerados',       valorUnitario: null },
      { slug: 'documentos.controle-desenhos',        label: 'Controle de Desenhos',     valorUnitario: null },
      { slug: 'documentos.certificados-de-material', label: 'Certificados de Material', valorUnitario: null },
    ],
  },
  {
    slug: 'qualidade',
    label: 'Qualidade',
    description: 'Ocorrências, planos de ação, auditorias, inspeções, calibrações, indicadores.',
    valorModulo: null,
    submodulos: [
      { slug: 'qualidade.ocorrencias',        label: 'Ocorrências',                        valorUnitario: null },
      { slug: 'qualidade.planos-acao',        label: 'Planos de Ação',                     valorUnitario: null },
      { slug: 'qualidade.auditorias',         label: 'Auditorias',                         valorUnitario: null },
      { slug: 'qualidade.inspecoes',          label: 'Inspeções — Qualidade',              valorUnitario: null },
      { slug: 'qualidade.calibracoes',        label: 'Calibrações',                        valorUnitario: null },
      { slug: 'qualidade.indicadores',        label: 'Indicadores',                        valorUnitario: null },
    ],
  },
  {
    slug: 'pessoas',
    label: 'Pessoas',
    description: 'CIPA, PDI, contracheque, ouvidoria, cargos, avaliação, recrutamento, treinamentos, EPIs, plano de treinamentos, relatórios RH.',
    valorModulo: null,
    submodulos: [
      { slug: 'pessoas.colaboradores',      label: 'Colaboradores',           valorUnitario: null },
      { slug: 'pessoas.cargos',             label: 'Cargos',                  valorUnitario: null },
      { slug: 'pessoas.recrutamento',       label: 'Recrutamento',            valorUnitario: null },
      { slug: 'pessoas.pdi',                label: 'PDI',                     valorUnitario: null },
      { slug: 'pessoas.plano-treinamentos', label: 'Plano de Treinamentos',   valorUnitario: null },
      { slug: 'pessoas.avaliacoes',         label: 'Avaliações',              valorUnitario: null },
      { slug: 'pessoas.treinamentos',       label: 'Treinamentos',            valorUnitario: null },
      { slug: 'pessoas.epis',               label: 'EPIs',                    valorUnitario: null },
      { slug: 'pessoas.pendencias',         label: 'Pendências',              valorUnitario: null },
      { slug: 'pessoas.cipa',               label: 'CIPA',                    valorUnitario: null },
      { slug: 'pessoas.contracheques',      label: 'Contracheques',           valorUnitario: null },
      { slug: 'pessoas.ouvidoria',          label: 'Ouvidoria',               valorUnitario: null },
      { slug: 'pessoas.relatorios',         label: 'Relatórios RH',           valorUnitario: null },
      { slug: 'pessoas.perfis',             label: 'Perfis de Acesso',        valorUnitario: null },
      { slug: 'pessoas.usuarios',           label: 'Usuários',                valorUnitario: null },
    ],
  },
  {
    slug: 'clientes',
    label: 'Clientes',
    description: 'Carteira de clientes, prospecção, orçamentos e pedidos, reclamações.',
    valorModulo: null,
    submodulos: [
      { slug: 'clientes.cadastro',           label: 'Clientes',                valorUnitario: null },
      { slug: 'clientes.prospeccao',         label: 'Gestão de Prospecção',    valorUnitario: null },
      { slug: 'clientes.orcamentos-pedidos', label: 'Orçamentos e Pedidos',    valorUnitario: null },
      { slug: 'clientes.contratos',            label: 'Contratos',               valorUnitario: null },
      { slug: 'clientes.reclamacoes',        label: 'Reclamações',             valorUnitario: null },
    ],
  },
  {
    slug: 'fornecedores',
    label: 'Fornecedores',
    description: 'Gestão de fornecedores — cadastro, qualificação (IQF) e relacionamento.',
    valorModulo: null,
    submodulos: [
      { slug: 'fornecedores.gestao', label: 'Gestão de Fornecedores', valorUnitario: null },
    ],
  },
  {
    slug: 'manutencao',
    label: 'Manutenção',
    description: 'Equipamentos, fichas, preventiva, corretiva, ordens de serviço, calendário.',
    valorModulo: null,
    submodulos: [
      { slug: 'manutencao.ordens-servico', label: 'Ordens de Serviço',  valorUnitario: null },
      { slug: 'manutencao.lista',           label: 'Todas as Manutenções', valorUnitario: null },
      { slug: 'manutencao.fichas',         label: 'Fichas de Máquinas', valorUnitario: null },
      { slug: 'manutencao.preventiva',     label: 'Preventiva',         valorUnitario: null },
      { slug: 'manutencao.corretiva',      label: 'Corretiva',          valorUnitario: null },
      { slug: 'manutencao.calendario',     label: 'Calendário', valorUnitario: null },
      { slug: 'manutencao.equipamentos',   label: 'Equipamentos',       valorUnitario: null },
    ],
  },
  {
    slug: 'tarefas',
    label: 'Tarefas',
    description: 'Gestão de tarefas individuais e de equipe.',
    valorModulo: null,
    submodulos: [
      { slug: 'tarefas.gestao', label: 'Gestão de Atendimentos', valorUnitario: null },
      { slug: 'tarefas.lista',   label: 'Tarefas',                valorUnitario: null },
    ],
  },
  {
    slug: 'projetos',
    label: 'Produtos',
    description: 'Portfólio de produtos, desenhos técnicos, critérios de inspeção e gestão de projetos.',
    valorModulo: null,
    submodulos: [
      { slug: 'projetos.produtos', label: 'Portfólio de Produtos', valorUnitario: null },
      { slug: 'projetos.gestao',   label: 'Gestão de Projetos',    valorUnitario: null },
    ],
  },
  {
    slug: 'relatorios',
    label: 'Relatórios',
    description: 'Relatórios consolidados: ASOs, auditorias, indicadores, RH, treinamentos, pessoas.',
    valorModulo: null,
    submodulos: [
      { slug: 'relatorios.dashboards',               label: 'Dashboard',                  valorUnitario: null },
      { slug: 'relatorios.asos',                     label: 'ASOs',                        valorUnitario: null },
      { slug: 'relatorios.auditorias',               label: 'Auditorias (consolidado)',    valorUnitario: null },
      { slug: 'relatorios.equipamentos',             label: 'Equipamentos',                valorUnitario: null },
      { slug: 'relatorios.indicadores',              label: 'Indicadores',                 valorUnitario: null },
      { slug: 'relatorios.leitura-documentos',       label: 'Leitura de Documentos',       valorUnitario: null },
      { slug: 'relatorios.ocorrencias',              label: 'Ocorrências (consolidado)',   valorUnitario: null },
      { slug: 'relatorios.pessoas',                  label: 'Pessoas',                     valorUnitario: null },
      { slug: 'relatorios.rh',                       label: 'RH',                          valorUnitario: null },
      { slug: 'relatorios.treinamentos',             label: 'Treinamentos (consolidado)',  valorUnitario: null },
      { slug: 'relatorios.treinamentos-colaborador', label: 'Treinamentos por Colaborador', valorUnitario: null },
    ],
  },
  {
    slug: 'ambiental',
    label: 'Ambiental',
    description: 'Gestão ambiental: aspectos, impactos, controles, monitoramentos, resíduos, licenças.',
    valorModulo: null,
    submodulos: [
      { slug: 'ambiental.painel',        label: 'Painel Ambiental',         valorUnitario: null },
      { slug: 'ambiental.aspectos',      label: 'Aspectos, Impactos e Controles',      valorUnitario: null },
      { slug: 'ambiental.monitoramentos', label: 'Monitoramentos',          valorUnitario: null },
      { slug: 'ambiental.residuos',      label: 'Resíduos',                 valorUnitario: null },
      { slug: 'ambiental.emergencias',   label: 'PAE — Emergências', valorUnitario: null },
      { slug: 'ambiental.requisitos',    label: 'Requisitos Legais',    valorUnitario: null },
    ],
  },
  {
    slug: 'integracoes',
    label: 'Integrações',
    description: 'API Keys e integrações externas (ERP, BI, etc). Add-on premium.',
    valorModulo: null,
    submodulos: [
      { slug: 'integracoes.api-keys', label: 'API Keys', valorUnitario: null },
    ],
  },
]

// Helpers ────────────────────────────────────────────────────────────

/** Retorna cópia limpa do seed (sem referências mutáveis). */
export const gerarCatalogoPadrao = () =>
  CATALOGO_SEED.map(m => ({
    ...m,
    submodulos: m.submodulos.map(s => ({ ...s })),
  }))

/**
 * Merge do SEED (estrutura canônica) com um mapa de preços { slug: valor }.
 * SEED é sempre a fonte da verdade da lista de módulos/submódulos e labels;
 * o mapa de preços só sobrescreve os campos de valor. Isso garante que:
 *   - Novos submódulos adicionados ao SEED aparecem automaticamente
 *   - Renomear label não perde o preço (slug é a chave)
 *   - Submódulos removidos do SEED simplesmente somem (preço órfão fica no
 *     mapa mas não aparece — não incomoda e pode voltar se o slug retornar)
 *
 * O mapa guarda, na mesma estrutura, o preço do MÓDULO INTEIRO sob a chave do
 * slug do módulo (ex.: 'negocio'). Não colide com submódulos porque estes
 * sempre usam slug composto ('negocio.reunioes').
 */
export const mergeCatalogoComPrecos = (mapaPrecos = {}) =>
  CATALOGO_SEED.map(m => ({
    ...m,
    valorModulo: mapaPrecos[m.slug] ?? m.valorModulo ?? null,
    submodulos: m.submodulos.map(s => ({
      ...s,
      valorUnitario: mapaPrecos[s.slug] ?? s.valorUnitario ?? null,
    })),
  }))

/**
 * Extrai o mapa { slug: valor } a partir de um catálogo (estrutura + preços).
 * Inclui o preço do módulo inteiro sob a chave do slug do módulo.
 * Ignora slugs com valor null/vazio (não polui o localStorage).
 */
export const extrairMapaPrecos = (catalogo = []) => {
  const mapa = {}
  for (const m of catalogo) {
    const vm = parseFloat(m.valorModulo)
    if (!isNaN(vm) && vm > 0) mapa[m.slug] = vm
    for (const s of (m.submodulos || [])) {
      const v = parseFloat(s.valorUnitario)
      if (!isNaN(v) && v > 0) mapa[s.slug] = v
    }
  }
  return mapa
}

/**
 * Subtotal de 1 submódulo dentro de 1 orçamento.
 * subtotal = valorUnitario × numEmpresas × (1 - desconto%)
 * Retorna 0 se valorUnitario não estiver preenchido.
 */
export const calcularSubtotalSubmodulo = ({ valorUnitario, numEmpresas = 1, descontoPct = 0 }) => {
  const v = parseFloat(valorUnitario) || 0
  const n = parseInt(numEmpresas, 10) || 1
  const d = Math.min(100, Math.max(0, parseFloat(descontoPct) || 0))
  return v * n * (1 - d / 100)
}

/**
 * Subtotal do MÓDULO INTEIRO (venda em bloco, sem detalhar submódulo).
 * subtotal = valorModulo × numEmpresas × (1 - desconto%)
 */
export const calcularSubtotalModuloInteiro = ({ valorModulo, numEmpresas = 1, descontoPct = 0 }) => {
  const v = parseFloat(valorModulo) || 0
  const n = parseInt(numEmpresas, 10) || 1
  const d = Math.min(100, Math.max(0, parseFloat(descontoPct) || 0))
  return v * n * (1 - d / 100)
}

/** true quando o módulo está sendo vendido inteiro (preço fechado). */
export const moduloVendidoInteiro = (mod) => mod?.modoVenda === 'inteiro'

/**
 * Total do módulo dentro do orçamento.
 * - modoVenda 'inteiro': preço fechado do módulo (submódulos vão todos juntos).
 * - modoVenda 'submodulos' (padrão): soma dos submódulos SELECIONADOS,
 *   cada um com desconto próprio.
 */
export const calcularTotalModulo = (moduloDoOrcamento, numEmpresas = 1) => {
  if (moduloVendidoInteiro(moduloDoOrcamento)) {
    return calcularSubtotalModuloInteiro({
      valorModulo: moduloDoOrcamento.valorModulo,
      numEmpresas,
      descontoPct: moduloDoOrcamento.descontoModuloPct,
    })
  }
  const subs = moduloDoOrcamento?.submodulos || []
  return subs.reduce((acc, s) => {
    if (!s.selecionado) return acc
    return acc + calcularSubtotalSubmodulo({
      valorUnitario: s.valorUnitario,
      numEmpresas,
      descontoPct: s.descontoPct,
    })
  }, 0)
}

/** true se o módulo entra no orçamento (inteiro, ou com ao menos 1 submódulo). */
export const moduloEstaNoOrcamento = (mod) =>
  moduloVendidoInteiro(mod) || (mod?.submodulos || []).some(s => s.selecionado)

/** Total geral do orçamento = soma dos totais de cada módulo. */
export const calcularTotalOrcamento = (orcamento) => {
  const modulos = orcamento?.modulos || []
  const n = orcamento?.numEmpresas || 1
  return modulos.reduce((acc, m) => acc + calcularTotalModulo(m, n), 0)
}

/**
 * Conta submódulos entregues no orçamento (pra badges/listagem).
 * Módulo vendido inteiro conta TODOS os seus submódulos — o cliente recebe tudo.
 */
export const contarSubmodulosSelecionados = (orcamento) => {
  const modulos = orcamento?.modulos || []
  return modulos.reduce((acc, m) => {
    const subs = m.submodulos || []
    return acc + (moduloVendidoInteiro(m) ? subs.length : subs.filter(s => s.selecionado).length)
  }, 0)
}

/**
 * Soma os "outros" itens do orçamento separados por recorrência.
 * Itens mensais entram no total mensal (e no anual x12); avulsos entram só no
 * anual (uma vez). Ignora linhas sem valor ou sem descrição.
 */
export const calcularTotaisExtras = (orcamento) => {
  const itens = orcamento?.itensExtras || []
  let mensal = 0
  let avulso = 0
  for (const it of itens) {
    const v = parseFloat(it.valor) || 0
    if (v <= 0) continue
    if (it.mensal) mensal += v
    else avulso += v
  }
  return { mensal, avulso }
}
